// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./~/font-awesome/css/font-awesome.css
 ** module id = 654
 ** module chunks = 0
 **/